<i18n>
{
  "en": {
    "online": "Your are back online. &#x1F44F;",
    "offline": "Your are offline. You still can navigate the website but some feature may not work. &#x1F634;",
    "newContent": "New content is available. Do you want to refresh?",
    "refreshButton": "refresh?"
  },
  "fr": {
    "online": "Vous ètes de retour en ligne. &#x1F44F;",
    "offline": "Vous ètres hors ligne. Vous pouvez toujours naviger sur le site mais cetaines fonctionalitées riquent de ne pas fonctioner. &#x1F634;",
    "newContent": "Mise à jour disponible. Voulez-vous rafraichir?",
    "refreshButton": "rafraichir?"
  }
}
</i18n>

<template>
  <header class="mdc-top-app-bar mdc-top-app-bar--dense">
    <div class="mdc-top-app-bar__row">
      <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
        <router-link to="/" class="material-icons mdc-top-app-bar__navigation-icon">home</router-link>
        <span class="mdc-top-app-bar__title" style="font-family:'ethnocentricregular'">Interlab</span>
      </section>
      <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
        <span
          v-on:click="openLangMenu"
          class="material-icons mdc-top-app-bar__action-item"
          aria-label="language"
          alt="language"
          style="z-index:10;"
        >
          language
          <div class="mdc-menu mdc-menu-surface" tabindex="-1" id="lang-menu">
            <ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical">
              <li class="mdc-list-item" data-lang="en" role="menuitem" v-on:click="changeLang">
                <span class="mdc-list-item__text">EN</span>
              </li>
              <li class="mdc-list-item" data-lang="fr" role="menuitem" v-on:click="changeLang">
                <span class="mdc-list-item__text">FR</span>
              </li>
            </ul>
          </div>
        </span>
        <router-link
          to="/docs"
          class="material-icons mdc-top-app-bar__action-item"
          aria-label="Download"
          alt="Download"
        >file_download</router-link>
        <router-link
          v-if="!authState.auth"
          :to="{ path: '/login', hash: referrer }"
          class="material-icons mdc-top-app-bar__action-item"
          aria-label="Login"
          alt="Login"
        >person</router-link>
        <router-link
          to="/settings/credential"
          v-if="authState.auth"
          class="material-icons mdc-top-app-bar__action-item"
          aria-label="User settings"
          alt="User settings"
        >person_outline</router-link>
        <span
          v-if="authState.auth"
          class="material-icons mdc-top-app-bar__action-item"
          aria-label="Logout"
          alt="Logout"
          @click="logout()"
        >exit_to_app</span>
      </section>
    </div>

    <div class="mdc-snackbar online">
      <div class="mdc-snackbar__surface" style="background-color: green;">
        <div class="mdc-snackbar__label" role="status" aria-live="polite">
          <span v-html="$t('online')"></span>
        </div>
      </div>
    </div>

    <div class="mdc-snackbar offline">
      <div class="mdc-snackbar__surface" style="background-color: red;">
        <div class="mdc-snackbar__label" role="status" aria-live="polite">
          <span v-html="$t('offline')"></span>
        </div>
      </div>
    </div>

    <div class="mdc-snackbar newContent">
      <div class="mdc-snackbar__surface">
        <div class="mdc-snackbar__label" role="status" aria-live="polite">
          <span v-html="$t('newContent')"></span>
        </div>
        <div class="mdc-snackbar__actions">
          <button
            type="button"
            class="mdc-button mdc-snackbar__action"
            v-html="$t('refreshButton')"
            v-on:click="reload"
          ></button>
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="js">
// import Vue from 'vue';
import { MDCTopAppBar } from '@material/top-app-bar/index';
import { MDCMenu } from '@material/menu';
import { MDCSnackbar } from '@material/snackbar';

import AuthManager from '../libs/authentication';

import getParent from 'dom-parents';

export default {
  name: 'navBare',
  data() {
    return {
      authState: this.$store.state,

      referrer: document.location.hash,

      onlineSnackBar: null,
      offlineSnackBar: null,
    };
  },
  watch: {
    $route(to, from) {
      this.referrer = document.location.hash;
    },
  },
  methods: {
    logout() {
      AuthManager.logout(this);
    },
    signalOnline() {
      this.offlineSnackBar.close('changed');
      this.onlineSnackBar.open();
    },
    signalOffline() {
      this.onlineSnackBar.close('changed');
      this.offlineSnackBar.open();
    },
    reload() {
      window.location.reload(true);
    },
    changeLang(ev) {
      const cleckedElement = getParent(ev.target, 'li', true)[0];
      localStorage.setItem('lang', cleckedElement.dataset.lang);
      this.reload();
    },
    openLangMenu() {
      const menu = new MDCMenu(document.querySelector('#lang-menu'));
      if (menu.open) {
        return;
      }

      menu.open = true;
    },
  },
  mounted() {
    AuthManager.checkAuth(this, this.$http);

    window.addEventListener('online', this.signalOnline);
    window.addEventListener('offline', this.signalOffline);

    this.onlineSnackBar = new MDCSnackbar(document.querySelector('header .mdc-snackbar.online'));
    this.onlineSnackBar.timeoutMs = 4000;
    this.offlineSnackBar = new MDCSnackbar(document.querySelector('header .mdc-snackbar.offline'));
    this.offlineSnackBar.timeoutMs = 10000;

    // Instantiation
    return new MDCTopAppBar(document.querySelector('.mdc-top-app-bar'));
  },
  destroyed() {
    this.onlineSnackBar.destroy();
    this.offlineSnackBar.destroy();
  },
};
</script>